import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

export interface DisplayNameOverrideDialogProps {
  open: boolean;
  title: string;
  canonicalName?: string;
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
  saving?: boolean;
  saveDisabled?: boolean;
  helperText?: string;
}

export const DisplayNameOverrideDialog = ({
  open,
  title,
  canonicalName,
  value,
  onChange,
  onClose,
  onSave,
  saving = false,
  saveDisabled = false,
  helperText = 'Leave empty to use the catalogue name.',
}: DisplayNameOverrideDialogProps) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>{title}</DialogTitle>
    <DialogContent dividers>
      <Stack spacing={1.5} sx={{ mt: 0.5 }}>
        <TextField
          size="small"
          label="Display name override"
          placeholder={canonicalName}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          helperText={helperText}
          disabled={saving}
        />
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button variant="outlined" onClick={onClose} disabled={saving}>
        Cancel
      </Button>
      <Button variant="contained" onClick={onSave} disabled={saveDisabled || saving}>
        Save
      </Button>
    </DialogActions>
  </Dialog>
);
